import React from 'react'

import { Route } from 'react-router'

import config from 'config/routes'
import { FullPage } from 'layouts/FullPage'

import { FoodBox, FoodBoxCmsCatchAll, LandingCmsCatchAll } from './MarketingPages'

export const FoodBoxPage = (
  <Route
    component={FullPage}
    props={{
      footerIsOnLandingPage: true,
    }}
  >
    <Route path={config.client.foodBox} component={FoodBox} />
  </Route>
)

export const FoodBoxCmsCatchAllPage = (
  <Route
    component={FullPage}
    props={{
      footerIsOnLandingPage: true,
    }}
  >
    <Route path="/food-box/*" component={FoodBoxCmsCatchAll} />
  </Route>
)

export const LandingCmsCatchAllPage = (
  <Route
    component={FullPage}
    props={{
      footerIsOnLandingPage: true,
    }}
  >
    <Route path="/landing/*" component={LandingCmsCatchAll} />
  </Route>
)
